// // Residencies.js
// import React, { useState, useEffect } from 'react';
// import './Residencies.css';
// import data from '../../utils/slider.json';

// function Residencies() {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const nextSlide = () => {
//     setCurrentSlide((prevSlide) => (prevSlide + 1) % data.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prevSlide) => (prevSlide - 1 + data.length) % data.length);
//   };

//   // Auto slide effect (optional)
//   useEffect(() => {
//     const timer = setTimeout(nextSlide, 5000); // Change slide every 5 seconds
//     return () => clearTimeout(timer); // Clear timer on component unmount or slide change
//   }, [currentSlide]);


//   return (
//     <section className="r-wrapper">
//       <div className="paddings innerWidth r-container">
//         {/* Header */}
//         <div className="r-header-buttons" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '20px' }}> {/* New container */}
//           <div className="r-head flexColStart">
//             <span className="orangeText" style={{ color: 'orange', fontWeight: 'bold' }}>Best Choice</span>
//             <span className="primaryText" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Popular Residencies</span>
//           </div>
//           <div className="r-buttons" style={{ display: 'flex', gap: '1rem' }}>
//             <button onClick={prevSlide} style={{ padding: '10px 15px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>&lt;</button>
//             <button onClick={nextSlide} style={{ padding: '10px 15px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>&gt;</button>
//           </div>
//         </div>

//         {/* Carousel */}
//         <div className="r-content" style={{ display: 'flex', gap: '1rem', overflowX: 'auto' }}>
//   {data.slice(currentSlide, currentSlide + 3).map((residency, index) => (
//     <div key={index} className="r-card" style={{ flex: '0 0 30%' }}>
//       <img src={residency.image} alt="home" />

//       <span className="secondaryText r-price"> {/* Price container */}
//         <span style={{ color: 'orange' }}>$</span> {/* Dollar sign */}

        
//         <span>{residency.price}</span> {/* Price value */}
//       </span>

//       <span className="primaryText">{residency.name}</span> {/* Name */}
//       <span className="secondaryText">{residency.detail}</span> {/* Details */}
//     </div>
//   ))}
// </div>

//         {/* Slider Controls */}
       

//       </div>
//     </section>
//   );
// }

// export default Residencies;
// Residencies.js
import React, { useState, useEffect } from 'react';
import './Residencies.css';
import data from '../../utils/slider.json';

function Residencies() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = data.length;

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + totalSlides) % totalSlides);
  };

  // Auto slide effect (optional)
  useEffect(() => {
    // const timer = setTimeout(nextSlide, 5000); // Change slide every 5 seconds
    // return () => clearTimeout(timer); // Clear timer on component unmount or slide change
  }, [currentSlide]);

  // Ensure we always display 3 cards
  const getVisibleResidencies = () => {
    return [
      data[currentSlide],
      data[(currentSlide + 1) % totalSlides],
      data[(currentSlide + 2) % totalSlides],
    ];
  };

  return (
    <section className="r-wrapper">
      <div className="paddings innerWidth r-container">
        {/* Header */}
        <div className="r-header-buttons" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '20px' }}>
          <div className="r-head flexColStart">
            <span className="orangeText" style={{ color: 'orange', fontWeight: 'bold' }}>Best Choice</span>
            <span className="primaryText" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Popular Residencies</span>
          </div>
          <div className="r-buttons" style={{ display: 'flex', gap: '1rem' }}>
            <button onClick={prevSlide} style={{ padding: '10px 15px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>&lt;</button>
            <button onClick={nextSlide} style={{ padding: '10px 15px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>&gt;</button>
          </div>
        </div>

        {/* Carousel */}
        <div className="r-content" style={{ display: 'flex', gap: '1rem', overflowX: 'auto' }}>
  {getVisibleResidencies().map((residency, index) => (
    <div key={index} className="r-card" style={{ flex: '0 0 30%' }}>
      <img src={residency.image} alt="home" />
      
      {/* Added a div to wrap price properly below the image */}
      <div className="r-price" style={{ marginTop: '10px', fontSize: '1.2rem', fontWeight: 'bold' }}>
        <span style={{ color: 'orange' }}>$</span>
        <span>{residency.price}</span>
      </div>

      <span className="primaryText">{residency.name}</span>
      <br />
      <span className="secondaryText">{residency.detail}</span>
    </div>
  ))}
</div>

      </div>
    </section>
  );
}

export default Residencies;
